export enum ConceptTypeLink{
    VideoCourse = 0, FoundationsOfLaw = 1, Blog = 2, ShortVideos = 3, Alias = 4
}